// Type definitions
type NavigateFunction = ((page: string | number, ...rest: any[]) => void) | null
type LocationChangedCallback = (location: Location) => void
type UnlistenFunction = () => void

interface HistoryObject {
  navigate: NavigateFunction
  location: Location
  push: (page: string, ...rest: any[]) => void
  replace: (page: string) => void
  goback: () => void
  back: (step?: number) => void
  locationChangeCBList: LocationChangedCallback[]
  listen: (handleLocationChange: LocationChangedCallback) => UnlistenFunction
  unlisten: (handleLocationChange: LocationChangedCallback) => void
  notifyLocationChange: (location: Location) => void
}

const History: HistoryObject = {
  navigate: null,
  location: window.location,
  push: (page: string, ...rest: any[]) => History.navigate!(page, ...rest),
  replace: (page: string) => History.navigate!(page, { replace: true }),
  goback: () => History.navigate!(-1),
  back: (step?: number) => {
    const num = step != null ? step : -1
    History.navigate!(num)
  },
  locationChangeCBList: [],
  listen: (handleLocationChange: LocationChangedCallback): UnlistenFunction => {
    if (History.locationChangeCBList.indexOf(handleLocationChange) < 0) {
      History.locationChangeCBList.push(handleLocationChange)
    }
    const ret = ((cbFunc: LocationChangedCallback) => {
      return () => {
        History.unlisten(cbFunc)
      }
    })(handleLocationChange)
    return ret
  },
  unlisten: (handleLocationChange: LocationChangedCallback) => {
    const pos = History.locationChangeCBList.indexOf(handleLocationChange)
    if (History.locationChangeCBList.indexOf(handleLocationChange) > -1) {
      History.locationChangeCBList.splice(pos, 1)
    }
  },
  notifyLocationChange: (location: Location) => {
    History.locationChangeCBList.forEach((cbFunc: LocationChangedCallback) => {
      cbFunc(location)
    })
  },
}

export default History
